<template>
    <form action="#" @submit.prevent="onSubmit" enctype="multipart/form-data">
        <slot></slot>
    </form>
</template>
<script>
export default {
    name: 'OForm',
    methods: {
        onSubmit(){
            this.$emit('submitted');
        }
    }
}
</script>